<template>
  <LoginWrapper>
    <template v-slot:main>
      <div v-if="!requestSent">
        <h2 class="login-title">Set the new password for your user account</h2>
        <div v-if="!hasResetCode">
          <NotificationBar type="error">
            <NotificationBarTitle>No reset code set. Please check your email for the link</NotificationBarTitle>
          </NotificationBar>

          <router-link to="/login">Back to login</router-link>
        </div>
        <div v-if="hasResetCode">
          <FormGroup v-bind:form="entryForm">
            <div class="row input-row mt-4 mb-2">
              <div class="col-12">
                <FormInputText
                  type="password"
                  placeholder="Password"
                  v-model="password"
                  field="password"
                  class="login-input"
                  icon="fa-lock"
                />
              </div>
            </div>
            <div class="row input-row my-2">
              <div class="col-12">
                <FormInputText
                  type="password"
                  placeholder="Confirm Password"
                  v-model="confirmPassword"
                  field="confirmPassword"
                  class="login-input"
                  icon="fa-lock"
                />
              </div>
            </div>
            <div class="row input-row my-4">
              <div class="col-12">
                <FormButton
                  type="submit"
                  :loading="submitting" 
                  @click="onUpdatePassword"
                  class="btn-lg block full-width login-submit">UPDATE PASSWORD</FormButton>
              </div>
            </div>
            <div class="row input-row">
              <div class="col-12 text-left login-recaptcha-notice">
                This site is protected by reCAPTCHA and the Google
                <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
                <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.
              </div>
            </div>
          </FormGroup>
        </div>
      </div>
      <div v-if="requestSent">
        <h2 class="login-title">Password successfully reset</h2>
        <div>Click <router-link to="/login">here</router-link> to login with your new password</div>
      </div>
    </template>
    <template v-slot:sidebar>
      <div class="login-side-title">Welcome</div>
        Already have an account?<br />
        <div class="mt-2">
          <router-link to="/login" class="login-sidebar-button">Sign In</router-link>
        </div>
    </template>
  </LoginWrapper>
</template>


<script>
import form from '@/mixins/form'
import LoginWrapper from '@/modules/core/components/loginWrapper'

export default {
  name: 'AccountResetForgottenPassword',
  mixins: [form],
  components: {
    LoginWrapper,
  },
  data: () => {
    return {
      resetCode: '',
      password: '',
      confirmPassword: '',
      entryForm: {},
      requestSent: false,
      submitting: false
    };
  },
  computed: {
    hasResetCode() {
      return this.resetCode && this.resetCode != ''
    },
  },
  mounted() {
    // Copy code which should be set from the reset password link in the email
    // Should really be no other way of getting to this page
    this.resetCode = this.$route.query.code || ''
  },
  methods: {
    async onUpdatePassword() {
      this.$data.entryForm = this.clearFormResponse()
      this.submitting = true

      try {
        // Ensure ReCaptcha is loaded & get the token
        await this.$recaptchaLoaded()
        let recaptchaToken = await this.$recaptcha('resetpassword')

        this.$api.post('/users/resetpassword', {
          code: this.resetCode,
          password: this.password,
          confirmPassword: this.confirmPassword,
          recaptchaToken: recaptchaToken
        })
        .then(response => {
          this.requestSent = true
        })
        .catch(err => {
          // Process errors
          this.$data.entryForm = this.processFormResponse(err);
        })
        .finally(() => {
          this.submitting = false
        })
      } catch(err) {
        this.$data.entryForm = this.processFormResponse('Error while processing request. If this continues, please check your internet connection or contact Synergy Software')
        this.submitting = false
      }
    }
  }
}
</script>